import { newsService } from "../services/news.service";
import { News, SentimentParams, SentimentParamsOptions } from "../models/news.models";
import { NewsListDO } from "../data/news.data";
import { capitalized, formatDate } from "../formatters";
import { DateOptionSet } from "../models/date.models";
import '../styles/news.style.scss'

export class NewsComponent extends HTMLDivElement {
    private static news: NewsListDO = { anomaly_news: [] }

    constructor() {
        super();
    }

    connectedCallback() {
        document.addEventListener('authChange', (event: Event) => {
            if (NewsComponent.news.anomaly_news.length === 0) {
                this.init()
            }
        });
    }

    async init() {
        NewsComponent.news = await newsService.load();
        if (!NewsComponent.news.anomaly_news) { console.error('No News Received'); return }
        if (NewsComponent.news.anomaly_news.length === 0) { return }

        this.className = 'tbw-news-container'
        this.createTopRow()
        
        NewsComponent.news.anomaly_news.forEach(news => {
            this.createNewsRow(news)
        })
    }

    private createTopRow() {
        const topRow = document.createElement('div')
        topRow.className = 'news-row top-row'

        topRow.innerHTML = `
            <div class='news-row-div is-large'>
                <div class='news-row-item first'><p class="caption1">News</p></div>
            </div>
            <div class='news-row-div'>
                <div class='news-row-item'><p class="caption1">Published</p></div>
                <div class='news-row-item'><p class="caption1">Source</p></div>
            </div>
        `

        this.appendChild(topRow)
    }

    private createTimeIcon(): SVGSVGElement {
        const timeIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg")
        timeIcon.setAttribute("width", "16")
        timeIcon.setAttribute("height", "17")
        timeIcon.setAttribute("viewBox", "0 0 16 17")
        timeIcon.setAttribute("fill", "none")

        timeIcon.innerHTML = `
            <path d="M5.24023 2.19952V4.16474" stroke="#161032" stroke-width="0.74211" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.4814 2.19952V4.16474" stroke="#292D32" stroke-width="0.74211" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.29297 6.84399H13.4292" stroke="#292D32" stroke-width="1.07194" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.7561 6.45749V12.0256C13.7561 13.9908 12.7735 15.301 10.4808 15.301H5.24021C2.94745 15.301 1.96484 13.9908 1.96484 12.0256V6.45749C1.96484 4.49227 2.94745 3.18213 5.24021 3.18213H10.4808C12.7735 3.18213 13.7561 4.49227 13.7561 6.45749Z" stroke="#292D32" stroke-width="1.07194" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        `
        return timeIcon
    }

    private createNewsRow(news: News) {
        const newsRow = document.createElement('div')
        newsRow.className = 'news-row'

        const sentiment: SentimentParams = SentimentParamsOptions[news.sentiment] ?? undefined
        const publishedDate = formatDate(new Date(news.published), DateOptionSet.anomalyDateEN)

        newsRow.innerHTML = `
            <a href="${news.link}" target="_blank" class='news-row-div is-link is-large'>
                ${sentiment ? `<img src="${sentiment.icon}" alt="Sentiment Icon" class='news-row-icon'>` : `<div class='news-row-icon'></div>`}
                <p class="caption1">${news.title}</p>
            </a>
            <div class='news-row-div'>
                <div class='news-row-item'>${this.createTimeIcon().outerHTML}<p class="caption1">${publishedDate}</p></div>
                <div class='news-row-item'><img src="${news.source_logo}" alt="News Image" class='news-row-logo'><p class="caption1">${capitalized(news.source_name)}</p></div>
            </div>
        `

        this.appendChild(newsRow)
    }
}

window.customElements.define('tbw-news', NewsComponent, { extends: 'div' });
